type CacheEntry = { promise: Promise<unknown>; expiresAt: number };

export function createReferenceCache({ scope, ttl = 30_000, maxEntries = 100, now = Date.now }: {
  scope: () => string; ttl?: number; maxEntries?: number; now?: () => number;
}) {
  const entries = new Map<string, CacheEntry>();
  let currentScope: string | undefined;
  const syncScope = () => {
    const next = scope();
    if (next !== currentScope) { entries.clear(); currentScope = next; }
  };
  return {
    async get<Value>(key: string, loader: () => Promise<Value>): Promise<Value> {
      syncScope();
      let entry = entries.get(key);
      if (!entry || entry.expiresAt <= now()) {
        if (entries.size >= maxEntries) entries.delete(entries.keys().next().value!);
        const pending: CacheEntry = { promise: Promise.resolve().then(loader), expiresAt: Infinity };
        entry = pending;
        entries.set(key, pending);
        pending.promise = pending.promise.then((value) => {
          pending.expiresAt = now() + ttl;
          return value;
        }, (failure) => {
          if (entries.get(key) === pending) entries.delete(key);
          throw failure;
        });
      }
      return structuredClone(await entry.promise) as Value;
    },
    invalidate(key: string) { entries.delete(key); },
    clear() { entries.clear(); },
  };
}
